/**
 * Static Data Reducer
 */

import * as actions from '../actions/staticData';

import { reducerWithInitialState } from 'typescript-fsa-reducers';

type ReducerState = IStaticDataState;
type Handler<K = undefined> = ReducerHandler<ReducerState, K>;

const defaultList = [];

export const initialState: ReducerState = {
  businessInformation: {},
  exchangeRates: defaultList,
  licenseComponents: {},
  taxonomies: defaultList,
  tempos: defaultList,
};

const setStaticDataHandler: Handler<ReducerState> = (state, newState) => ({
  ...state,
  ...newState,
});

export default reducerWithInitialState(initialState)
  .case(actions.setStaticData, setStaticDataHandler);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/reducers/staticData.ts